
import { Button } from "react-bootstrap";
import "./index.css";

const Inicio = () => {
  return (
    <div className="d-flex">
      <div className="p-3"><Button>Descargar</Button></div>
      <div className="p-3"><Button>Datos utiles</Button></div>
    </div>
  );
};


export default Inicio;